const validTime = value => {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : null;
};

const messageTime = message => validTime(message.sentAt) ?? validTime(message.createdAt) ?? Infinity;

const mergeMessage = (previous, incoming) => {
  const merged = { ...previous, ...incoming };
  // A late HTTP/history snapshot must not undo newer delivery/read receipts.
  if (Number.isFinite(previous.ack)) {
    merged.ack = Number.isFinite(incoming.ack) ? Math.max(previous.ack, incoming.ack) : previous.ack;
  }
  if (validTime(incoming.sentAt) === null && validTime(previous.sentAt) !== null) merged.sentAt = previous.sentAt;
  if (validTime(incoming.createdAt) === null && validTime(previous.createdAt) !== null) merged.createdAt = previous.createdAt;
  return merged;
};

const mergeTimeline = (state, incoming, updateOnly = false) => {
  const merged = [...state];
  const indexes = new Map(merged.map((message, index) => [message.id, index]));
  incoming.forEach(message => {
    if (!message || message.id == null) return;
    const index = indexes.get(message.id);
    if (index !== undefined) merged[index] = mergeMessage(merged[index], message);
    else if (!updateOnly) {
      indexes.set(message.id, merged.length);
      merged.push(message);
    }
  });
  // Explicit index tie-break keeps established order for equal provider seconds.
  return merged.map((message, index) => ({ message, index, time: messageTime(message) }))
    .sort((left, right) => left.time === right.time ? left.index - right.index : left.time < right.time ? -1 : 1)
    .map(entry => entry.message);
};

export const messageBelongsToTicket = (message, ticketId) =>
  message?.ticketId != null && ticketId != null && String(message.ticketId) === String(ticketId);

export const messageTimelineReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_MESSAGES": return mergeTimeline(state, action.payload || []);
    case "ADD_MESSAGE": return mergeTimeline(state, [action.payload]);
    case "UPDATE_MESSAGE": return mergeTimeline(state, [action.payload], true);
    case "RESET": return [];
    default: return state;
  }
};
